import React from "react";
import { Provider } from "react-redux";
import { useEffect, useState } from "react";
import {
    BrowserRouter,
    Route,
    Routes,
    Navigate,
    useNavigate,
    useLocation,
} from "react-router-dom";

import SignIn from "./pages/signIn";
import Error from "./components/common/Error";
import ClipWrapperLayout from "./components/ClipWrapperLayout";

import { history } from "./components/utils";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "video.js/dist/video-js.css";
import modelObj from "./utils/cookieUtils";

function App() {
    history.navigate = useNavigate();
    history.location = useLocation();

    const navigate = useNavigate();

    const [useLang, setUseLang] = useState();

    useEffect(() => {
        var langState = modelObj.getLocalStorage("language");
        var accessToken = modelObj.getLocalStorage("accessToken");

        var pathname = history.location.pathname;
        var nav = pathname.split("/");

        if (
            typeof langState == "undefined" ||
            langState == "undefined" ||
            langState == null
        ) {
            setUseLang("kr");
            modelObj.addItemOnLocalStorage("language", "kr");
        } else {
            setUseLang(langState);
        }
        modelObj.renderLanguage();

        //조건문 다시 작성하기
        if(nav[1] == "clip"){
            // console.log("페이지 호출");
            if(accessToken == null){
                // console.log("토큰이 없을 경우");
                navigate("/");
            } 
        } 
        else if(nav[1] == "" || nav[1] == "signin"){
            // console.log("루트 페이지 접근");
            if(accessToken != null){
                // console.log("토큰이 있을 경우");
                navigate("/clip/gameCriteria");
            }
        }

    }, [useLang]);

    return (
        <Routes>
            <Route path="/" element={<SignIn />}></Route>
            <Route path="/signin" element={<SignIn />}></Route>
            <Route path="/error" element={<Error />}></Route>
            <Route
                path="/clip/*"
                element={
                    <ClipWrapperLayout
                        useLang={useLang}
                        setUseLang={setUseLang}
                    />
                }
            ></Route>
        </Routes>
    );
}

export default App;
